import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppServiceService } from 'src/app/api/app-service.service';
import { DatePipe } from '@angular/common';
import { ModalController } from '@ionic/angular';
import { SelectOrderTypePage } from "../modals/select-order-type/select-order-type.page";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.page.html',
  styleUrls: ['./checkout.page.scss'],
})
export class CheckoutPage implements OnInit {
  @Output() onNavigatePages: EventEmitter<any> = new EventEmitter();
  @Output() onChangeDeliveryAddress: EventEmitter<any> = new EventEmitter();
  @Output() onOrderPlaced: EventEmitter<any> = new EventEmitter();
  @Input() backFromAddressSelect = false;
  // user decide to go back and login to the account for purchase rewards (points system change for web version)
  @Output() onBackLoginFromCheckout: EventEmitter<any> = new EventEmitter();

  @HostBinding('style.--radio-color')
  public radioColor: any = this.appService.appObject?.theme[this.appService.themeConfigFor]?.primaryColor ? this.appService.appObject?.theme[this.appService.themeConfigFor]?.primaryColor : '';

  public selectedRadio = '';
  todayDate: any;
  selectedDate: any;
  deleveryAvailableTimes: any = [];
  deliveryDates: any = [];
  selectedTimes: any = [];
  firstTime: boolean = true;
  street_number: string = '';
  showSelectAddressError: boolean = false;
  house_number: string = '';

  // start postal code feature 
  public deliveryAddress: string = '';
  public postalCodeDetails: any = null;
  // end postal code feature 

  selectedTimesLoading: boolean = true;

  checkoutForm = null;
  deliveryMethod = this.appService.appObject.selectedDeliveryMethod;

  currentlySelectedAddress = '';
  public isBarModeEnabled: boolean = false;

  // point system related
  public userPoints: any = null;
  public isOrderAmountPointsReached: boolean = false;
  public totalPointRequirement: string = '';
  public isMinimumPointsAmountReached: boolean = false;
  public pointConfig: any = null;
  public lang: any = null;

  constructor(public appService: AppServiceService, private datePipe: DatePipe, private router: Router, public modalController: ModalController, public translate: TranslateService) {
    this.canRoute();

    this.appService.className2 = ' cart-top';

    setTimeout(() => {
      this.getDeliveryTimes();
      this.checkoutForm.value.payment_type = this.appService.appObject.selectedRestaurantDetails.default_payment_method;
      this.selectedRadio = this.appService.appObject.selectedRestaurantDetails.default_payment_method;
      if (this.appService.appObject.isAuthed) {
        this.getUserDetails();
      } else {
        this.updateFormData();
      }
    }, 1000);

    this.currentlySelectedAddress = this.appService.appObject.myAddress && this.appService.appObject.myAddress.name ? this.appService.appObject.myAddress.name : '';

    if (this.backFromAddressSelect) {
      this.onDismissAddressSelect();
    }

    this.validator();

    // auto fill the street number if available from previousely selected valid address
    this.street_number = appService.appObject.myAddress && appService.appObject.myAddress.streetNo ? appService.appObject.myAddress.streetNo : '';

    if (this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.is_bar_mode === 'true') {
      this.isBarModeEnabled = true;
    }

    if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.settings.is_postalcode === 'true') {
      // console.log('postal code details : ', this.appService.appObject.postalCodeDetails);
      this.postalCodeDetails = this.appService.appObject.postalCodeDetails;
    }

    this.getLang();
  }

  ngDoCheck() {
    this.radioColor = this.appService.appObject.theme[this.appService.themeConfigFor]?.primaryColor || '';
  }

  validator() {
    // form validators
    // check if the mobile number is required by the restaurant when placing an order
    let isMobileNumberRequired = this.appService.appObject.selectedRestaurantDetails ? this.appService.appObject.selectedRestaurantDetails.is_mobile_number : false;

    let mobileNumberValidations = isMobileNumberRequired === 'true' ? [Validators.required] : [];
    mobileNumberValidations.push(Validators.minLength(9));
    mobileNumberValidations.push(Validators.maxLength(30));
    mobileNumberValidations.push(Validators.pattern(/(\(?([\d \-\)\–\+\/\(]+)\)?([ .\-–\/]?)([\d]+))/));

    if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
      // set all the form validators
      this.checkoutForm = new FormGroup({
        name: new FormControl('', {
          validators: [
            Validators.required,
            Validators.pattern(/\w+\s\w+/)
          ],
          updateOn: 'change'
        }),
        mobile_number: new FormControl('', {
          validators: mobileNumberValidations,
          updateOn: 'change'
        }),
        email: new FormControl('', {
          validators: [
            Validators.required,
            // Validators.pattern("^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$"),
            Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"),
          ],
          updateOn: 'change'
        }),
        special_note: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        payment_method: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_date: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_time: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        address: new FormControl('', {
          validators: [],
          updateOn: 'change',
        }),
        street_number: new FormControl('', {
          validators: [
            Validators.required,
          ],
          updateOn: 'change',
        }),
        // house_number: new FormControl('', {
        //   validators: [
        //     Validators.required,
        //   ],
        //   updateOn: 'change',
        // }),
      });
    } else if (this.appService.appObject.selectedDeliveryMethod === 'delivery') {
      // set all the form validators
      this.checkoutForm = new FormGroup({
        name: new FormControl('', {
          validators: [
            Validators.required,
            Validators.pattern(/\w+\s\w+/)
          ],
          updateOn: 'change'
        }),
        mobile_number: new FormControl('', {
          validators: mobileNumberValidations,
          updateOn: 'change'
        }),
        email: new FormControl('', {
          validators: [
            Validators.required,
            // Validators.pattern("^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$"),
            Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"),
          ],
          updateOn: 'change'
        }),
        backyard: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        special_note: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        payment_method: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_date: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_time: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        street_number: new FormControl('', {
          validators: [
            Validators.required,
            // Validators.pattern("^[0-9]*$"),
          ],
          updateOn: 'change',
        }),
      });
    } else {
      // set all the form validators
      this.checkoutForm = new FormGroup({
        name: new FormControl('', {
          validators: [
            Validators.required,
            Validators.pattern(/\w+\s\w+/)
          ],
          updateOn: 'change'
        }),
        mobile_number: new FormControl('', {
          validators: mobileNumberValidations,
          updateOn: 'change'
        }),
        email: new FormControl('', {
          validators: [
            Validators.required,
            // Validators.pattern("^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$"),
            Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"),
          ],
          updateOn: 'change'
        }),
        backyard: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        special_note: new FormControl('', {
          validators: [
          ],
          updateOn: 'change'
        }),
        payment_method: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_date: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        }),
        delivery_time: new FormControl('', {
          validators: [
            Validators.required
          ],
          updateOn: 'change'
        })
      });
    }
  }

  canRoute() {
    if (this.appService.appObject.deviceUUID == "") {
      setTimeout(() => {
        if (this.appService.appObject.orderObject.cart.length == 0) {
          this.appService.routeToSelectedRestaurant();
        }
      }, 100);
    }
  }

  ionViewWillEnter() {
    this.appService.hideCartButton = false;
  }

  onChangeHandler($event) {
    this.checkoutForm.value.payment_type = $event.target.value;
  }

  ionViewWillLeave() {
    console.log('leaveng');
    this.appService.hideCartButton = true;
    this.appService.className2 = ' ';
  }

  getUserDetails() {
    this.userPoints = null;

    this.appService.getUserDetails({ 'customer_id': this.appService.appObject.userId }).then(data => {
      if (data.status) {
        this.appService.appObject.user.fname = data.data.first_name;
        this.appService.appObject.user.lname = data.data.last_name;
        this.appService.appObject.user.email = data.data.email;
        this.appService.appObject.user.telephone = data.data.mobile_number;
        this.updateFormData();

        // get user's reward points 
        if (data.data.points && data.data.points !== '[]') {
          let userPoints = JSON.parse(data.data.points);
          Object.keys(userPoints).map((key) => {
            // get the usable points for selected restaurant
            if (key === (this.appService.appObject.selectedRestaurantId + '')) {
              // remove decimals 
              userPoints[key].points = userPoints[key].points ? userPoints[key].points.toFixed(0) : userPoints[key].points;
              this.userPoints = userPoints[key];
            }
          });


          // points system related
          let restaurantPaymentMethods = this.appService.appObject.selectedRestaurantDetails.payment_methods;
          let pointsEnabled = restaurantPaymentMethods.find((method) => method.id === 'points' && method.isActive === 'true');
          if (this.userPoints && pointsEnabled && pointsEnabled.config && this.appService.appObject.orderObject.cart_summery && this.appService.appObject.orderObject.cart_summery.gross_total) {
            this.pointConfig = pointsEnabled.config;
            let grossTotal = this.appService.appObject.orderObject.cart_summery.gross_total;
            // console.log('pointConfig : ' , pointConfig);

            let pointValue = (+this.pointConfig.valueInPoints) / (+this.pointConfig.valueInCurrency);
            let totalPointRequirement = grossTotal * pointValue;
            this.isOrderAmountPointsReached = (this.userPoints.points >= totalPointRequirement) ? true : false;

            // check the minimum point amount reached
            this.isMinimumPointsAmountReached = (totalPointRequirement >= (+this.pointConfig.minPoints)) ? true : false;

            this.totalPointRequirement = totalPointRequirement.toFixed(0);
            // console.log('this.isOrderAmountPointsReached : ' , this.isOrderAmountPointsReached , ' | totalPointRequirement : ' , totalPointRequirement, ' | ',this.userPoints.points);
          }
        }
      }
    });
  }

  updateFormData() {
    this.checkoutForm.get('name').setValue(this.appService.appObject.user.fname + ' ' + this.appService.appObject.user.lname);
    this.checkoutForm.get('email').setValue(this.appService.appObject.user.email);
    this.checkoutForm.get('mobile_number').setValue(this.appService.appObject.user.telephone);

    if (this.appService.appObject.settings.is_postalcode === 'true' && this.appService.appObject.postalCodeExtraDetails) {
      this.checkoutForm.get('address').setValue(this.appService.appObject.postalCodeExtraDetails.address);
      this.checkoutForm.get('street_number').setValue(this.appService.appObject.postalCodeExtraDetails.streetNumber);
    }
  }

  placeOrder() {
    // console.log('checkoutdetails.payment_method : ' , this.checkoutForm.value.payment_method);
    // added another condition to point payment gateway, just in case
    if (this.checkoutForm.value.payment_method === 'points' && this.appService.appObject.selectedDeliveryMethod === 'dine_in' && this.appService.appObject.selectedRestaurantDetails.is_bar_mode === 'true' && (!this.isOrderAmountPointsReached || !this.isMinimumPointsAmountReached)) return;

    // Postal code mode validations 
    if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
      if (this.appService.appObject.postalCodeDetails) {
        let listOfPostalCodes = this.appService.appObject.selectedRestaurantDetails.postal_code_details;
        if (listOfPostalCodes) {
          if (!Array.isArray(listOfPostalCodes)) listOfPostalCodes = JSON.parse(listOfPostalCodes);
          let selectedExists = listOfPostalCodes.find((postalCode) => postalCode.code === this.appService.appObject.postalCodeDetails.code);
          if (!selectedExists) {
            this.appService.showToast(this.lang.selected_restaurent_not_delivery_city, 'danger');
            return;
          }
          else console.log('postal code supported');
        } else {
          // show error
          this.appService.showToast(this.lang.selected_restaurent_not_delivery_city, 'danger');
          return;
        }
      } else {
        // show error
        console.log('postal code not selected by user');
        return;
      }
    }

    this.showSelectAddressError = false;
    console.log(this.checkoutForm);
    this.checkoutForm.markAsTouched();
    this.checkoutForm.controls['name'].markAsTouched();
    this.checkoutForm.controls['email'].markAsTouched();
    this.checkoutForm.controls['mobile_number'].markAsTouched();
    this.checkoutForm.controls['delivery_date'].markAsTouched();
    this.checkoutForm.controls['delivery_time'].markAsTouched();

    if (this.appService.appObject.selectedDeliveryMethod === 'delivery') this.checkoutForm.controls['street_number'].markAsTouched();

    // if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') this.checkoutForm.controls['house_number'].markAsTouched();

    //this.keyboard.disableScroll(false);
    let d_date = this.checkoutForm.value.delivery_date;
    if (this.checkoutForm.valid) {
      if (this.checkoutForm.value.delivery_time == 'asap') {
        d_date = 'asap';
      }
      let checkoutdetails = this.checkoutForm.value;
      this.appService.appObject.orderObject.order_details.name = checkoutdetails.name.trim();
      this.appService.appObject.orderObject.order_details.email = checkoutdetails.email.trim();
      this.appService.appObject.orderObject.order_details.mobile_number = checkoutdetails.mobile_number;
      this.appService.appObject.orderObject.order_details.backyard = checkoutdetails.backyard;
      this.appService.appObject.orderObject.order_details.special_note = checkoutdetails.special_note;
      this.appService.appObject.orderObject.order_details.payment_type = checkoutdetails.payment_method;
      this.appService.appObject.orderObject.order_details.delivery_date = d_date;
      this.appService.appObject.orderObject.order_details.delivery_time = checkoutdetails.delivery_time;
      this.appService.appObject.orderObject.order_details.delivery_type = this.appService.appObject.selectedDeliveryMethod;
      // console.log('this.appService.appObject.myAddress.name : ', this.appService.appObject.myAddress.name);

      if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode !== 'true') {
        let streetNumber = checkoutdetails.street_number.trim();

        if (streetNumber && this.currentlySelectedAddress) {
          let splitedAddress = this.currentlySelectedAddress.split(',');
          let newAddress = '';
          if (splitedAddress.length === 3) {
            newAddress = splitedAddress[0].trim() + ', ' + streetNumber + ', ' + splitedAddress[1].trim() + ', ' + splitedAddress[2].trim();
          } else if (splitedAddress.length === 4) {
            newAddress = splitedAddress[0].trim() + ', ' + streetNumber + ', ' + splitedAddress[2].trim() + ', ' + splitedAddress[3].trim();
          }
          this.appService.appObject.myAddress.name = newAddress;
        }
      } else if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
        this.appService.appObject.myAddress.name = checkoutdetails.address.trim();
        let streetNumber = checkoutdetails.street_number.trim();
        // let houseNumber = checkoutdetails.house_number.trim();
        // concat postal code details to end of the user entered address
        if (this.appService.appObject.myAddress.name) {
          this.appService.appObject.myAddress.name += (' ' + streetNumber) + (', ' + this.postalCodeDetails.name + ' ' + this.postalCodeDetails.code);
        }
      }

      // check address string only if the selected ordering method is delivery
      if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && !this.appService.appObject.myAddress.name) {
        this.showSelectAddressError = true;
        return;
      }

      if (!this.appService.isWebVersion) this.appService.placeOrder();
      else {
        let paymentOp = this.appService.appObject.orderObject.order_details.payment_type;
        if (paymentOp === 'cod' || paymentOp === 'ecCard' || paymentOp === 'points') {
          this.appService.placeOrder(true).then((response: any) => {
            if (response.payment_id) this.onOrderPlaced.emit([response.payment_id, this.appService.appObject.selectedDeliveryMethod]);
          }).catch((error) => {
            console.log('user canceled or error ', error);
          })
        } else {
          this.appService.placeOrder(true);
        }
      }

      // keep last order postal code details after placing an order
      if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.settings.is_postalcode === 'true') {
        this.appService.appObject.postalCodeExtraDetails = {
          streetNumber: checkoutdetails.street_number.trim(),
          address: checkoutdetails.address.trim()
        }

        this.appService.updateAppObject();
      }

    } else {
      if (this.checkoutForm.controls.name.status == "INVALID") {
        document.getElementById("name").focus();
      } else if (this.checkoutForm.controls.email.status == "INVALID") {
        document.getElementById("email").focus();
      } else if (this.checkoutForm.controls.mobile_number.status == "INVALID") {
        document.getElementById("mobile_number").focus();
      }

    }

  }

  ngOnInit() {
    //var date = new Date();
    //this.todayDate = this.datePipe.transform(date, "yyyy-MM-dd");
    // console.log(this.todayDate);

  }

  async getDays(e) {
    // console.log('get days:', e.detail.value);

    if (/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(e.detail.value)) {

      this.selectedTimes = this.deleveryAvailableTimes[e.detail.value];
      this.selectedDate = e.detail.value;

    } else {

      this.selectedTimes = this.deleveryAvailableTimes[this.todayDate];
      this.selectedDate = this.todayDate;
    }


    this.checkoutForm.get('delivery_time').setValue('');

  }

  async getDeliveryTimes() {
    this.appService.getOpenTimes().then(data => {
      if (data.status) {
        // console.log(data.data);
        this.deleveryAvailableTimes = data.data;
        this.todayDate = data.today;

        Object.keys(data.data).forEach(key => {
          this.deliveryDates.push(key);
          if (key === this.todayDate) {
            // console.log('selecting', key);
            this.selectedDate = this.todayDate;

          }
        });

        setTimeout(() => {
          this.checkoutForm.get('delivery_date').setValue(this.selectedDate);
          // call get days function to trigger (ionChange) event manually in delivery_date select list,
          // otherwise it won't call because of ngIf condition in select list
          this.getDays({ detail: { value: this.selectedDate } });

          if (this.selectedDate == this.todayDate && !this.appService.appObject.selectedRestaurantDetails?.openDetails?.is_pre_order) {
            this.checkoutForm.get('delivery_time').setValue('asap');
          } else if (this.selectedDate == this.todayDate && this.appService.appObject.selectedRestaurantDetails?.openDetails?.is_pre_order) {
            // set first value as default value
            if (this.selectedTimes.length) this.checkoutForm.get('delivery_time').setValue(this.selectedTimes[0]);
          }
          this.selectedTimesLoading = false;
        }, 1000);



      } else {
        this.selectedTimesLoading = false;
      }
    }, error => {
      this.appService.appObject.isLoading = false;
      this.selectedTimesLoading = false;
    });
  }

  emailvalidation() {
    if (this.checkoutForm.value.email) {
      this.checkoutForm.get('email').setValue(this.checkoutForm.value.email.trim());
    }
  }

  /**
   * This will redirect user to given route
   * @param location string value of route path
   */
  async navigateTo(slug) {
    if (!this.appService.isWebVersion)
      this.router.navigate([slug === 'tnc' ? '/pages/tnc' : '/pages/pnp'])
    else {
      this.onNavigatePages.emit([slug]);
    }
  }

  /**
   * When user change address
   */
  changeDeliveryLocation() {
    if (!this.appService.isWebVersion) this.openAddressChangePopup()// this.router.navigate(['/find-near-by-me'])
    else this.onChangeDeliveryAddress.emit();
  }

  /**
   * When user change Payment Method
   */
  OnChangePaymentMethod($event) {
    this.selectedRadio = $event?.target?.value;
  }

  async openAddressChangePopup() {

    const modal = await this.modalController.create({
      component: SelectOrderTypePage,
      cssClass: 'custom-popup',

      componentProps: {
        'currentUI': 'delivery-address',
        'just_select_address': 'true',
        'is_from_checkout_page': 'true'
      }
    });

    await modal.present();

    modal.onDidDismiss().then((dismissed) => {
      this.onDismissAddressSelect();
    });
  }

  onDismissAddressSelect() {
    if (this.appService.appObject.myAddress && this.appService.appObject.myAddress.name && this.appService.appObject.myAddress.lat && this.appService.appObject.myAddress.lng) {
      this.currentlySelectedAddress = this.appService.appObject.myAddress.name;
      // auto fill the street number if available from previousely selected valid address
      this.street_number = this.appService.appObject.myAddress && this.appService.appObject.myAddress.streetNo ? this.appService.appObject.myAddress.streetNo : '';
    } else {
      this.currentlySelectedAddress = '';
      this.street_number = '';
    }
  }

  /**
   * Login in from points reward warnning message
   */
  loginInClicked() {
    if (!this.appService.isWebVersion) {
      this.router.navigate(['login'], { queryParams: { isOrderProcess: true } });
    } else {
      this.onBackLoginFromCheckout.emit();
    }
  }

  /**
   * 
   * get languages
   */
  async getLang() {
    await this.translate.get('key').subscribe(
      value => {
        this.lang = value;
      }
    )
  }

}
